export default class DataStatuses {
  static TO_EXTRACT = "toExtract";

  static TO_RECONCILE = "toReconcile";

  static TO_REPORT = "toReport";

  static TO_REVIEW = "toReview";

  static EXCLUDED = "excluded";

  static EXPORTED = "exported";

  static NEED_DOCUMENT = "needDocument";

  static NEED_REACTION = "needReaction";

  static IN_PROGRESS = "inProgress";
}
